import { render, staticRenderFns } from "./OperaCarouselWindow.vue?vue&type=template&id=46756f8c&"
import script from "./OperaCarouselWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCarouselWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCarouselWindow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports